var _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipientWidgetRu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 45,
    viewBox: "0 0 200 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Recipient Name"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 13884",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h200v45H0z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1v43h198V1H1M0 0h200v45H0V0z",
    style: {
      fill: "#333",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "Select Recipient Name",
    transform: "translate(17 28)",
    style: {
      fill: "#333",
      fontSize: 14,
      fontFamily: "Roboto-Medium,Roboto",
      fontWeight: 500
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0438\u043C\u044F \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F"))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13805",
    d: "M84 120.1a1.537 1.537 0 0 1 .435-1.065 1.512 1.512 0 0 1 2.13 0l4.56 4.545 4.56-4.56a1.506 1.506 0 0 1 2.13 2.13l-5.625 5.625a1.485 1.485 0 0 1-1.065.435 1.55 1.55 0 0 1-1.065-.435l-5.625-5.61A1.564 1.564 0 0 1 84 120.1z",
    transform: "translate(86.563 -99.906)",
    style: {
      fill: "#777"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipientWidgetRu);
export default __webpack_public_path__ + "static/media/recipient-widget-ru.9e4567aee4f19c89ae8f0a9030a50ae9.svg";
export { ForwardRef as ReactComponent };